import { render, staticRenderFns } from "./ZonesParametersTab.vue?vue&type=template&id=83dda9f6&"
import script from "./ZonesParametersTab.vue?vue&type=script&lang=js&"
export * from "./ZonesParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports